import { FC } from 'react'
import { Checkbox, Col, Form, Row } from 'antd'

const FormItem = Form.Item

const RECOMMENDATION_STATUS_OPTIONS = [
  {
    label: 'Pending',
    value: 'PENDING',
  },
  {
    label: 'In Review',
    value: 'IN_REVIEW',
  },
  {
    label: 'Accept',
    value: 'APPROVED',
  },
  {
    label: 'Reject',
    value: 'DECLINED',
  },
]

export type Props = {
  value: string
  onChange: (value: string) => void
}

const RecommendationStatusFilter: FC<Props> = ({ value, onChange }) => {
  const handleChange = (selectedValues: Array<string>) => {
    const addedValue = selectedValues.find((status) => status !== value)

    onChange(addedValue ?? '')
  }

  return (
    <Col span={12}>
      <FormItem label="Recommendation status">
        <Row>
          <Col span={13}>
            <span data-test-id="recommendationStatusFilter">
              <Checkbox.Group
                className="CaseFiltersContainer--recommendationStatus"
                value={value ? [value] : []}
                onChange={handleChange}
                options={RECOMMENDATION_STATUS_OPTIONS}
              />
            </span>
          </Col>
        </Row>
      </FormItem>
    </Col>
  )
}

export default RecommendationStatusFilter
